'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var themes = require('@wow/themes');
var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@chakra-ui/react');
var reactFeather = require('react-feather');

const {
  colors: {
    primary: primary$4
  },
  sizes: sizes$1
} = themes.themeChakra;
const progressStyle = {
  filledTrack: {
    backgroundImage: `linear-gradient( to right, ${primary$4[90]} 100%, ${primary$4[90]} 100% );`
  },
  track: {
    background: primary$4[60],
    borderRadius: sizes$1[4]
  }
};
const baseStyle$2 = progressStyle;
const ProgressChakra = {
  baseStyle: baseStyle$2
};

const {
  colors: {
    primary: primary$3
  },
  fonts: {
    body: body$1
  },
  fontWeights
} = themes.themeChakra;
const baseStyle$1 = {
  size: themes.numToRem(57.15),
  filledTrack: {
    color: primary$3[90]
  },
  track: {
    width: themes.numToRem(7),
    color: primary$3[60]
  },
  label: {
    fontFamily: body$1,
    fontSize: themes.numToRem(14),
    fontWeight: fontWeights.bold,
    lineHeight: themes.numToRem(20),
    letterSpacing: themes.numToRem(0.1)
  }
};
const CircularProgressChakra = {
  baseStyle: baseStyle$1
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$a =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$5 = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$4 = fails$5;

// Thank's IE8 for his funny defineProperty
var descriptors = !fails$4(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectPropertyIsEnumerable = {};

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var fails$3 = fails$5;
var classof = classofRaw;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$3(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$3 = function (it) {
  return IndexedObject$1(requireObjectCoercible$1(it));
};

var isObject$4 = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var isObject$3 = isObject$4;

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive$2 = function (input, PREFERRED_STRING) {
  if (!isObject$3(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$3(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject$3(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$3(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var hasOwnProperty = {}.hasOwnProperty;

var has$5 = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var global$9 = global$a;
var isObject$2 = isObject$4;

var document = global$9.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject$2(document) && isObject$2(document.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document.createElement(it) : {};
};

var DESCRIPTORS$4 = descriptors;
var fails$2 = fails$5;
var createElement = documentCreateElement;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$4 && !fails$2(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$3 = descriptors;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$2 = toIndexedObject$3;
var toPrimitive$1 = toPrimitive$2;
var has$4 = has$5;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$3 ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$2(O);
  P = toPrimitive$1(P, true);
  if (IE8_DOM_DEFINE$1) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$4(O, P)) return createPropertyDescriptor$1(!propertyIsEnumerableModule$1.f.call(O, P), O[P]);
};

var objectDefineProperty = {};

var isObject$1 = isObject$4;

var anObject$2 = function (it) {
  if (!isObject$1(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

var DESCRIPTORS$2 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var anObject$1 = anObject$2;
var toPrimitive = toPrimitive$2;

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$2 ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPrimitive(P, true);
  anObject$1(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$1 = descriptors;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;

var createNonEnumerableProperty$4 = DESCRIPTORS$1 ? function (object, key, value) {
  return definePropertyModule$1.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$1 = {exports: {}};

var global$8 = global$a;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;

var setGlobal$3 = function (key, value) {
  try {
    createNonEnumerableProperty$3(global$8, key, value);
  } catch (error) {
    global$8[key] = value;
  } return value;
};

var global$7 = global$a;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$7[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store$2.inspectSource != 'function') {
  store$2.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$2 = store$2.inspectSource;

var global$6 = global$a;
var inspectSource$1 = inspectSource$2;

var WeakMap$1 = global$6.WeakMap;

var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource$1(WeakMap$1));

var shared$1 = {exports: {}};

var store$1 = sharedStore;

(shared$1.exports = function (key, value) {
  return store$1[key] || (store$1[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode: 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

var id = 0;
var postfix = Math.random();

var uid$1 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var shared = shared$1.exports;
var uid = uid$1;

var keys = shared('keys');

var sharedKey$1 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$3 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$5 = global$a;
var isObject = isObject$4;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
var objectHas = has$5;
var sharedKey = sharedKey$1;
var hiddenKeys$2 = hiddenKeys$3;

var WeakMap = global$5.WeakMap;
var set, get, has$3;

var enforce = function (it) {
  return has$3(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$3 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$2[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty$2(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$3 = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$3,
  enforce: enforce,
  getterFor: getterFor
};

var global$4 = global$a;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var has$2 = has$5;
var setGlobal$1 = setGlobal$3;
var inspectSource = inspectSource$2;
var InternalStateModule = internalState;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(redefine$1.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has$2(value, 'name')) createNonEnumerableProperty$1(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global$4) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$1(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});

var global$3 = global$a;

var path$1 = global$3;

var path = path$1;
var global$2 = global$a;

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn$1 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global$2[namespace])
    : path[namespace] && path[namespace][method] || global$2[namespace] && global$2[namespace][method];
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger$2 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var toInteger$1 = toInteger$2;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min$1(toInteger$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger = toInteger$2;

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var toIndexedObject$1 = toIndexedObject$3;
var toLength = toLength$1;
var toAbsoluteIndex = toAbsoluteIndex$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$1($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var has$1 = has$5;
var toIndexedObject = toIndexedObject$3;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$1 = hiddenKeys$3;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$1(hiddenKeys$1, key) && has$1(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$1(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$2 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$2;

var hiddenKeys = enumBugKeys$1.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn = getBuiltIn$1;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject = anObject$2;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var has = has$5;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$1 = fails$5;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails$1(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$1 = global$a;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty = createNonEnumerableProperty$4;
var redefine = redefine$1.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$1;
  } else if (STATIC) {
    target = global$1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$2;

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys$1 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

var requireObjectCoercible = requireObjectCoercible$2;

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject$1 = function (argument) {
  return Object(requireObjectCoercible(argument));
};

var DESCRIPTORS = descriptors;
var fails = fails$5;
var objectKeys = objectKeys$1;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$1;
var IndexedObject = indexedObject;

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
var objectAssign = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;

var $ = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const CircularProgressComponent = _a => {
  var {
      children,
      isIndeterminate
    } = _a,
    props = __rest(_a, ["children", "isIndeterminate"]);
  const {
    baseStyle: {
      filledTrack,
      label,
      track,
      size
    }
  } = CircularProgressChakra;
  return jsxRuntime.jsx(react.CircularProgress, Object.assign({
    size: size,
    trackColor: track.color,
    thickness: track.width,
    color: filledTrack.color,
    isIndeterminate: isIndeterminate
  }, props, {
    children: jsxRuntime.jsx(react.CircularProgressLabel, Object.assign({}, label, {
      children: children
    }))
  }));
};

const {
  colors: {
    primary: primary$2
  },
  sizes
} = themes.themeChakra;
const spinnerStyle = {
  borderWidth: sizes[4],
  width: sizes[48],
  height: sizes[48],
  color: primary$2[90],
  borderBottomColor: primary$2[90],
  borderLeftColor: primary$2[60]
};
const defaultSpinner = spinnerStyle;
const spinnerButtonStyle = {
  borderWidth: themes.numToRem(1.4),
  width: sizes[16],
  height: sizes[16]
};
const defaultButtonSpinner = spinnerButtonStyle;
const SpinnerChakra = {
  variants: {
    default: defaultSpinner,
    'default-button': defaultButtonSpinner
  },
  defaultProps: {
    variant: 'default-button'
  }
};

const {
  colors: {
    primary: primary$1,
    tertiary: tertiary$1,
    neutral,
    white
  },
  fonts: {
    body
  },
  fontWeights: {
    regular
  }
} = themes.themeChakra;
const StepProgressIndicatorChakra = {
  container: {
    baseStyle: {
      height: 'auto',
      width: 'auto',
      padding: 0,
      margin: 0
    }
  },
  dot: {
    baseStyle: {
      borderRadius: themes.numToRem(5),
      height: themes.numToRem(8),
      minWidth: themes.numToRem(8),
      padding: 0,
      backgroundColor: primary$1[70],
      cursor: 'default',
      _active: {
        backgroundColor: primary$1[110],
        minWidth: themes.numToRem(24)
      },
      _hover: {
        backgroundColor: primary$1[110]
      },
      _focus: {
        backgroundColor: primary$1[110]
      }
    },
    variants: {
      dark: {
        backgroundColor: tertiary$1[60],
        _active: {
          backgroundColor: tertiary$1[110],
          minWidth: themes.numToRem(24)
        },
        _hover: {
          backgroundColor: tertiary$1[110]
        },
        _focus: {
          backgroundColor: tertiary$1[110]
        }
      }
    }
  },
  nominal: {
    baseStyle: {
      width: 'auto',
      color: neutral[120],
      fontFamily: body,
      fontSize: themes.numToRem(14),
      fontWeight: regular,
      lineHeight: themes.numToRem(20),
      letterSpacing: themes.numToRem(0.1),
      textAlign: 'left'
    },
    variants: {
      dark: {
        color: white
      }
    }
  }
};
const Container$1 = react.chakra(react.Stack, Object.assign({
  shouldForwardProp: () => true
}, StepProgressIndicatorChakra.container));
const DotStep$1 = react.chakra(react.Button, Object.assign({
  shouldForwardProp: () => true
}, StepProgressIndicatorChakra.dot));
const NominalStep = react.chakra(react.Box, Object.assign({
  shouldForwardProp: () => true
}, StepProgressIndicatorChakra.nominal));

const {
  nominal: {
    variants: {
      dark: darkNominal
    }
  },
  dot: {
    variants: {
      dark: darkDot
    }
  }
} = StepProgressIndicatorChakra;
const StepProgressIndicatorComponent = ({
  steps,
  currentStep: currentIndex,
  type,
  variant,
  onStepClick
}) => {
  const Nominal = jsxRuntime.jsx(NominalStep, Object.assign({}, variant === 'dark' ? Object.assign({}, darkNominal) : null, {
    children: `${currentIndex}/${steps}`
  }));
  const Dot = () => {
    const dots = [];
    for (let x = 0; x < steps; x++) {
      const isActive = x === currentIndex - 1;
      dots.push(jsxRuntime.jsx(DotStep$1, Object.assign({
        isActive: isActive
      }, variant === 'dark' ? Object.assign({}, darkDot) : null, {
        onClick: onStepClick
      }), `dot-step-${x}`));
    }
    return dots;
  };
  return jsxRuntime.jsx(Container$1, Object.assign({
    direction: 'row'
  }, {
    children: type === 'nominal' ? Nominal : Dot()
  }));
};

const {
  colors: {
    grey
  }
} = themes.themeChakra;
const baseStyle = {
  height: themes.numToRem(24),
  '--skeleton-start-color': grey[50],
  '--skeleton-end-color': grey[30]
};
const SkeletonChakra = {
  baseStyle
};

const {
  colors: {
    primary,
    tertiary
  }
} = themes.themeChakra;
const CarouselControllerChakra = {
  container: {
    baseStyle: {
      height: 'auto',
      width: 'auto',
      padding: 0,
      margin: 0
    }
  },
  dot: {
    baseStyle: {
      borderRadius: themes.numToRem(5),
      height: themes.numToRem(8),
      minWidth: themes.numToRem(8),
      padding: 0,
      backgroundColor: primary[70],
      cursor: 'default',
      transition: 'min-width 0.15s ease-in-out',
      _active: {
        backgroundColor: primary[110],
        transition: 'min-width 0.2s ease-in-out',
        minWidth: themes.numToRem(24)
      },
      _hover: {
        backgroundColor: primary[110]
      },
      _focus: {
        backgroundColor: primary[110]
      }
    },
    variants: {
      dark: {
        backgroundColor: tertiary[60],
        _active: {
          backgroundColor: tertiary[30],
          minWidth: themes.numToRem(24)
        },
        _hover: {
          backgroundColor: tertiary[30]
        },
        _focus: {
          backgroundColor: tertiary[30]
        }
      }
    }
  }
};
const Container = react.chakra(react.Stack, Object.assign({
  shouldForwardProp: () => true
}, CarouselControllerChakra.container));
const DotStep = react.chakra(react.Button, Object.assign({
  shouldForwardProp: () => true
}, CarouselControllerChakra.dot));

const {
  dot: {
    variants: {
      dark
    }
  }
} = CarouselControllerChakra;
const CarouselController = ({
  steps,
  currentStep,
  variant: _variant = 'light',
  onStepClick,
  withChevrons: _withChevrons = false
}) => {
  const goToStep = stepDelta => {
    onStepClick((currentStep - 1 + stepDelta + steps) % steps + 1);
  };
  const dots = Array.from({
    length: steps
  }, (_, index) => jsxRuntime.jsx(DotStep, Object.assign({
    isActive: index === currentStep - 1,
    marginLeft: index > 0 ? 8 : 0
  }, _variant === 'dark' ? dark : {}, {
    onClick: () => onStepClick(index + 1)
  }), `dot-step-${index}`));
  const chevronProps = {
    variant: `icon${_variant === 'light' ? '' : '-dark'}-text`,
    size: 'i-md'
  };
  return jsxRuntime.jsxs(Container, Object.assign({
    direction: 'row',
    alignItems: "center",
    css: {
      [_withChevrons ? '>button:nth-of-type(-n+2), >button:last-of-type' : '>button:first-of-type']: {
        marginInlineStart: '0 !important'
      }
    }
  }, {
    children: [_withChevrons && jsxRuntime.jsx(react.IconButton, Object.assign({
      "aria-label": "previous",
      "data-testid": "chevron-button"
    }, chevronProps, {
      onClick: () => goToStep(-1),
      icon: jsxRuntime.jsx(react.Icon, {
        as: reactFeather.ChevronLeft
      })
    })), dots, _withChevrons && jsxRuntime.jsx(react.IconButton, Object.assign({
      "aria-label": "next",
      "data-testid": "chevron-button"
    }, chevronProps, {
      onClick: () => goToStep(1),
      icon: jsxRuntime.jsx(react.Icon, {
        as: reactFeather.ChevronRight
      })
    }))]
  }));
};

exports.CarouselController = CarouselController;
exports.CarouselControllerChakra = CarouselControllerChakra;
exports.CircularProgressChakra = CircularProgressChakra;
exports.CircularProgressComponent = CircularProgressComponent;
exports.ProgressChakra = ProgressChakra;
exports.SkeletonChakra = SkeletonChakra;
exports.SpinnerChakra = SpinnerChakra;
exports.StepProgressIndicatorChakra = StepProgressIndicatorChakra;
exports.StepProgressIndicatorComponent = StepProgressIndicatorComponent;
exports.progressStyle = progressStyle;
exports.spinnerStyle = spinnerStyle;
